
/* injects from baggage-loader */

'use strict';

import ProjectEditorController from './project-editor.controller';
import ProjectEditorTemplate from './project-editor.html';

export default class ProjectEditorComponent {
		constructor() {
				this.templateUrl = ProjectEditorTemplate;
				this.controller = ProjectEditorController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					comments: '<',
					documents: '<',
					rewards: '<',
					sections: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/project-editor/project-editor.component.js